import React from 'react';
import { Button } from '@mui/material';

const styles = {
  uploadButton: {
    verticalAlign: 'middle',
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
};

const FilePicker = ({
  buttonText = 'Choose File',
  disabled = false,
  onFileSelection,
  selectedFileName,
  startIcon,
}) => (
  <div>
    <span>
      <Button
        disabled={disabled}
        startIcon={startIcon}
        color="primary"
        variant="contained"
        style={styles.uploadButton}
      >
        {buttonText}
        <input
          disabled={disabled}
          type="file"
          style={styles.uploadInput}
          onChange={onFileSelection}
        />
      </Button>
      {selectedFileName}
    </span>
  </div>
);

export default FilePicker;
